<template>
  <div>
    <v-row class="d-flex" v-if="false">
      <template v-if="false">
        <v-col cols="12" lg="6">
          <v-card class="elevation-12">
            <v-card-title>ЭСЛАТМА !</v-card-title>
            <v-card-text class="subtitle-1">
              <p class="text-justify">
                Ўзбекистон Республикаси Вазирлар Маҳкамасининг 2020 йил 14 августдаги 489-cонли қарори билан тасдиқланган
                Низомга мувофиқ ҳисобот ойи учун ҳисобот ойидан кейинги ойнинг <b>10 санасига</b> қадар электрон
                ҳисобварақ-фактураларни расмийлаштириш шартлигини маълум қиламиз.
                <br>Шунингдек, етказиб берувчи томонидан юборилган электрон ҳисобварақ-фактура <b>10 кун</b> давомида
                сотиб
                олувчи
                томонидан тасдиқланмаса ёки сабаби кўрсатилган ҳолда рад этилмаса автоматик равишда <b>тасдиқланган</b>
                ҳолатга
                ўтказилиши бўйича огоҳлантирамиз.
              </p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6">
          <v-card class="elevation-12">
            <v-card-title>НАПОМИНАНИЕ !</v-card-title>
            <v-card-text class="subtitle-1">
              <p class="text-justify">
                Сообщаем, что в соответствии с Положением, утвержденным постановлением Кабинета Министров Республики
                Узбекистан от 14 августа 2020 года №489, вводится порядок обязательного оформления электронных
                счетов-фактур
                <b>до 10 числа</b> месяца, следующего за отчетным.
                <br>Также предупреждаем, что отправленные поставщиком электронные счета-фактуры, не принятые (не
                подтвержденные) покупателем или не отклоненные с указанием причины в течение <b>10 календарных дней</b>,
                автоматически переводятся в <b>принятые</b> (подтвержденные).
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </template>

      <v-col cols="12">
        <v-card class="d-flex align-stretch" flat>
          <v-card color="#1F7087" dark class="elevation-6" outlined>
            <v-card-title class="text-h5">Телеграм уведомления</v-card-title>
            <v-card-text>
              Получайте уведомления о новых действиях через телеграм моментально.
              <br>
              Добавьте свои контактные данные и подпишитесь на нашего бота в Telegram, чтобы получать уведомления.
              <br>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn class="ml-2 mt-2" outlined rounded small :href="telegramBotUrl">Подписаться на бота</v-btn>
              <v-btn class="ml-2 mt-2" outlined rounded small @click="onTriggerOpenContacts">Добавить</v-btn>
            </v-card-actions>
          </v-card>

          <v-card color="#1F7087" dark class="elevation-6 ml-5" v-if="false">
            <v-card-title class="text-h5">Hippo.uz</v-card-title>
            <v-card-subtitle>
              Система для контроля процесса торговли, склада и производство товаров.
              <br>
              С Hippo.uz получите полный и удалённый доступ к своему складу в облаке и легкое управление взаимоотношениями между поставщиками и клиентами.
              Вести учёт и анализ действий вашего бизнеса по отношению к товару.
            </v-card-subtitle>
            <v-card-actions>
              <v-spacer />
              <v-btn class="ml-2 mt-2" outlined rounded small href="https://hippo.uz"> Открыть сайт</v-btn>
              <v-btn class="ml-2 mt-2" outlined rounded small href="https://hippo.sog.uz"> Открыть приложение</v-btn>
            </v-card-actions>
          </v-card>
        </v-card>
      </v-col>

    </v-row>
<!--    <v-row>
      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-10">
          <v-card-title>
            <v-spacer/>
            Заказы
            <v-spacer/>
          </v-card-title>
          <v-card-text>
            <div class="text-center">
              <v-icon size="64" color="primary">assignment_turned_in</v-icon>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue darken-1" text :to="{name: 'order-add'}">Новый</v-btn>
            <v-spacer/>
            <v-btn color="blue darken-1" text :to="{name: 'orders-all'}">Все</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-10">
          <v-card-title class="text-center">
            <v-spacer/>
            Поставки
            <v-spacer/>
          </v-card-title>
          <v-card-text>
            <div class="text-center">
              <v-icon size="64" color="primary">subdirectory_arrow_right</v-icon>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="blue darken-1" text :to="{name: 'shipment-all'}">Все</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-10">
          <v-card-title class="text-center">
            <v-spacer/>
            Счёт-фактуры
            <v-spacer/>
          </v-card-title>
          <v-card-text>
            <div class="text-center">
              <v-icon size="64" color="primary">fa-file-signature</v-icon>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="blue darken-1" text :to="{name: 'invoice-all'}">Все</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>-->

<!--    <v-row>
      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-10">
          <v-card-title>
            <v-spacer/>
            Заказы на возврат
            <v-spacer/>
          </v-card-title>
          <v-card-text>
            <div class="text-center">
              <v-icon size="64" color="primary">assignment_return</v-icon>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue darken-1" text :to="{name: 'return-order-add'}">Новый</v-btn>
            <v-spacer />
            <v-btn color="blue darken-1" text :to="{name: 'return-orders-all'}">Все</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-10">
          <v-card-title>
            <v-spacer/>
            Накладные на возврат
            <v-spacer/>
          </v-card-title>
          <v-card-text>
            <div class="text-center">
              <v-icon size="64" color="primary">subdirectory_arrow_left</v-icon>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text :to="{name: 'return-shipment-all'}">Все</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-10">
          <v-card-title>
            <v-spacer/>
            Возвратные счёт-фактуры
            <v-spacer/>
          </v-card-title>
          <v-card-text>
            <div class="text-center">
              <v-icon size="64" color="primary">fa-file-signature</v-icon>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="blue darken-1" text :to="{name: 'return-invoices-all'}">Все</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>-->

    <v-row>
<!--      <v-col cols="12" md="6" lg="4" v-if="!$store.getters.isKorzinkaLogin">-->
<!--        <v-card class="elevation-10">-->
<!--          <v-card-title>-->
<!--            <v-spacer/>-->
<!--            Статистика-->
<!--            <v-spacer/>-->
<!--          </v-card-title>-->
<!--          <v-card-text>-->
<!--            <div class="text-center">-->
<!--              <v-icon size="64" color="primary">bar_chart</v-icon>-->
<!--            </div>-->
<!--          </v-card-text>-->
<!--          <v-card-actions>-->
<!--            <v-spacer/>-->
<!--            <v-btn color="blue darken-1" text :to="{name: 'statistics-dashboard'}">Открыть</v-btn>-->
<!--          </v-card-actions>-->
<!--        </v-card>-->
<!--      </v-col>-->
      <v-col cols="12" md="6" lg="4" v-if="$store.getters.isKorzinkaLogin">
        <v-card class="elevation-10">
          <v-card-title>
            <v-spacer/>
            Акты
            <v-spacer/>
          </v-card-title>
          <v-card-text>
            <div class="text-center">
              <v-icon size="64" color="primary">fa-check-square</v-icon>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="blue darken-1" text :to="{name: 'korzinka-dashboard'}">Открыть</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {APP_BILLING_PACKAGES_PATH, NotificationServiceSettings} from '@/settings'
import {TriggerOpenContacts} from "@/eventbus/events"

export default {
  name: "Dashboard",
  data() {
    return {
      appBillingServicePath: APP_BILLING_PACKAGES_PATH,
      telegramBotUrl: NotificationServiceSettings.TelegramBotUrl,
    }
  },
  methods: {
    onTriggerOpenContacts() {
      this.$bus.$emit(TriggerOpenContacts)
    }
  }
}
</script>

<style scoped>

</style>